import styled from 'styled-components';

import { typography } from '@theme/font';
import { COLORS } from '@theme/colors';
import { OFFSET } from '@theme/helpers';
import { disabledButtonContainerStyles } from '@components/common';
import { media } from '@theme/media';

export const Container = styled.div<{ isDisabled: boolean }>`
  display: flex;
  padding: ${OFFSET.XS} 0 ${OFFSET.XS} ${OFFSET.XS};
  gap: ${OFFSET.XS};
  background: ${COLORS.SILVER};

  ${({ isDisabled }) => isDisabled && disabledButtonContainerStyles}

  ${media.mobile} {
    border-top: 1px solid ${COLORS.BLACK40};
    border-bottom: 1px solid ${COLORS.BLACK40};
    background: transparent;
    padding: ${OFFSET.XS} 0;
  }
`;

export const Label = styled.label``;

export const Option = styled.option`
  color: ${COLORS.BLACK};
`;

export const Select = styled.select`
  ${typography({})};
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
  color: ${COLORS.BLACK};
  background: transparent;
  color: ${COLORS.BLACK};
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 97%;
  background-position-y: 50%;
  border: 0;
  padding: 0 ${OFFSET.XS};
  flex-grow: 1;

  &:hover {
    cursor: pointer;
  }

  ${media.mobile} {
    background-position-x: 100%;
  }
`;
